var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.menulist.length > 1
    ? _c(
        "div",
        [
          _c(
            "a-tabs",
            {
              staticStyle: {
                background: "#f0f2f5",
                "text-align": "center",
                margin: "0px 10px"
              },
              attrs: { size: "large" }
            },
            [
              _vm.menulist.indexOf("dashboard/JCHomeIndex") !== -1
                ? _c(
                    "a-tab-pane",
                    { key: "0", attrs: { tab: "稽核人" } },
                    [_c("JCHomeIndex")],
                    1
                  )
                : _vm._e(),
              _vm.menulist.indexOf("dashboard/HomeIndexTo") !== -1
                ? _c(
                    "a-tab-pane",
                    { key: "1", attrs: { tab: "被稽核人" } },
                    [_c("HomeIndexTo")],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm.menulist.length === 1
    ? _c(
        "div",
        [
          _vm.menulist.indexOf("dashboard/JCHomeIndex") !== -1
            ? _c("JCHomeIndex")
            : _vm.menulist.indexOf("dashboard/HomeIndexTo") !== -1
            ? _c("HomeIndexTo")
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }